export default "__VITE_ASSET__DiFQC67G__"